<template>
  <v-autocomplete
    v-model="selectedCampanha"
    label="Campanhas"
    item-text="nome"
    item-value="id"
    :items="arrayCampanhas"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedCampanha.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules"
import { Campanhas } from "@/services/materiais"

export default {
  name: "SelectCampanha",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    empresas: {
      type: Array | String,
      required: false
    },

    mounted: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },

    independent: {
      type: Boolean,
      default: false
    },

    selected: {
      type: String || Array,
      default: null
    }
  },

  data() {
    return {
      selectedCampanha: this.selected || [],
      arrayCampanhas: [],

      rules: rules
    };
  },

  methods: {
    async getAll() {
      try{
        let campanhas = await new Campanhas().list()
        this.arrayCampanhas = campanhas
      }catch(error) {
        this.$toast.error(error)
      }
    },

    async getCampanhasByEmpresas() {
      try {
        let campanhas = await new Campanhas().getByEmpresa(this.empresas)
        this.arrayCampanhas = campanhas
      } catch (error) {
        this.$toast.error(error)
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedCampanha = this.arrayCampanhas.map(
          value => value.id
        )
      } else {
        this.selectedCampanha = []
      }

      this.onChanged()
    },

    onChanged() {
      this.$emit("onChanged", this.selectedCampanha);
    }
  },

  watch: {
    empresas: {
      handler() {
        this.selectedCampanha = []
        this.getCampanhasByEmpresas()
      },
      deep: true
    }
  },

  mounted() {
    if(this.independent) this.getAll()
  }
};
</script>
